import { render, staticRenderFns } from "./FormTableComponent.vue?vue&type=template&id=0a831bde&"
import script from "./FormTableComponent.vue?vue&type=script&lang=js&"
export * from "./FormTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports